import { useNode } from '@craftjs/core';
import React, { useCallback } from 'react';
import { Phone, Password } from '@descope/page-editor-components';
import { EditorInputSettings } from '../EditorInput/EditorInputSettings';

type Props = React.ComponentProps<typeof Phone>;

const EditorPassword = (props: Props) => {
	const {
		connectors: { connect, drag }
	} = useNode();

	const refCb = useCallback(
		(ref: HTMLDivElement) => connect(drag(ref)),
		[connect, drag]
	);

	return <Password ref={refCb} type="password" {...props} readOnly />;
};

EditorPassword.craft = {
	name: 'Login Password',
	props: {
		name: 'password',
		type: 'password',
		placeholder: 'Password',
		label: 'Password',
		size: 'md',
		fullWidth: true,
		autoComplete: null as any // we cannot use undefined because we getting the uncontrolled to controlled warning, and empty string is adding the attribute to the dom
	},
	related: {
		settings: EditorInputSettings
	}
};

export { EditorPassword };
